// helperFunctions/sessionStorage.ts

export const getSessionStorage = (key: string) => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  };
  
  export const setSessionStorage = (key: string, value: any) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore errors
    }
  };
  